import MainLayout from '@components/Shared/Layout';
import { ROUTE_PATHS } from '@constants/routes';
import ActivationPage from '@pages/Activation';
import LicensesPage from '@pages/Licenses';
import LoginPage from '@pages/Login';
import OfflineUsagePage from '@pages/OfflineUsage';
import SeatUsagePage from '@pages/SeatUsage';
import ActivationLogsPage from '@pages/ActivationLogs';
import SeatSessionsPage from '@pages/SeatSessions';
import SettingsPage from '@pages/Settings';
import SetupPage from '@pages/Setup';
import { useGetConfigQuery } from '@store/api/rootEndpoints';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

const AppRouter = () => {
  const { data: config, isLoading } = useGetConfigQuery();

  // Nothing is rendered until the server has said whether it is set up. Guessing and correcting
  // would flash the sign-in form at somebody who has no account to sign in with.
  if (isLoading) return null;

  // An installation with no administrator serves 503 on every other route, so there is nothing
  // else worth routing to. One destination, and everything leads to it.
  if (config?.setupRequired) {
    return (
      <Router>
        <Routes>
          <Route path={ROUTE_PATHS.SETUP} element={<SetupPage />} />
          <Route path={ROUTE_PATHS.NOT_FOUND} element={<Navigate to={ROUTE_PATHS.SETUP} replace />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path={ROUTE_PATHS.LOGIN} element={<LoginPage />} />
        <Route path={ROUTE_PATHS.SETUP} element={<Navigate to={ROUTE_PATHS.LOGIN} replace />} />

        <Route element={<MainLayout />}>
          <Route path={ROUTE_PATHS.HOME} element={<Navigate to={ROUTE_PATHS.ACTIVATION} replace />} />
          <Route path={ROUTE_PATHS.ACTIVATION} element={<ActivationPage />} />
          <Route path={ROUTE_PATHS.LICENSES} element={<LicensesPage />} >
            <Route index element={null} />
            <Route path={ROUTE_PATHS.LICENSE} element={null} />
          </Route>
          <Route path={ROUTE_PATHS.SEAT_USAGE} element={<SeatUsagePage />} />
          <Route path={ROUTE_PATHS.SEAT_SESSIONS} element={<SeatSessionsPage />} />
          <Route path={ROUTE_PATHS.ACTIVITY} element={<ActivationLogsPage />} />
          <Route path={ROUTE_PATHS.OFFLINE_USAGE} element={<OfflineUsagePage />} />
          <Route path={ROUTE_PATHS.SETTINGS} element={<SettingsPage />} />
        </Route>

        <Route path={ROUTE_PATHS.NOT_FOUND} element={<Navigate to={ROUTE_PATHS.HOME} replace />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
